/* src/app/job-signoff-workshop/pages/job-signoff-workshop-manager-view/job-signoff-workshop-manager-view.component.scss */
/*# sourceMappingURL=job-signoff-workshop-manager-view.component.css.map */
